import { render, staticRenderFns } from "./PendingSwap.vue?vue&type=template&id=5124cf0a&scoped=true&"
import script from "./PendingSwap.vue?vue&type=script&lang=ts&"
export * from "./PendingSwap.vue?vue&type=script&lang=ts&"
import style0 from "./PendingSwap.vue?vue&type=style&index=0&id=5124cf0a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5124cf0a",
  null
  
)

export default component.exports